export const environment = {
    production: true,
    apiBaseUrl: '',
    compositionApiBaseUrl: '',
    weatherWidgetUrlTemplate:
        'https://www.meteoblue.com/en/weather/widget/three/{city}?geoloc=fixed&nocurrent=0&noforecast=0&days=4&tempunit=CELSIUS&windunit=KILOMETER_PER_HOUR&layout=bright',
};
